import {
  DEFAULT_COLOR_GRAY,
  DEFAULT_MARKDOWN_TEXT,
  DEFAULT_TEXT,
} from '../constants'
import { baseSchemaProperties } from '../base-schema-properties'
import { titleSchemaProperties, blockShadowSchemaProperties } from '../common'

export default {
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'Accordion',
  description: 'List with drop-down texts',
  type: 'object',
  required: ['tabs', 'textColor'],
  properties: {
    ...baseSchemaProperties,
    ...titleSchemaProperties,
    numeration: {
      title: 'Numeration',
      type: 'boolean',
      default: true,
    },
    align: {
      title: 'Content align',
      type: 'string',
      enum: ['justify-start', 'justify-center', 'justify-end', 'w-full'],
      enumNames: ['Left', 'Center', 'Right', 'Full width'],
      default: 'w-full',
      'ui:hidden': '{{!!parentFormData.image}}',
    },
    maxWidth: {
      title: 'Max width of the text (in px)',
      description:
        "If it's not set, the text will be 100% width of the block (default is 576)",
      type: 'number',
      'ui:hidden':
        '{{!!parentFormData.image || parentFormData.align === "w-full"}}',
    },
    ...blockShadowSchemaProperties,
    textColor: {
      title: 'Text color',
      type: 'string',
      default: DEFAULT_COLOR_GRAY,
    },
    imageTopPadding: {
      title: 'Image top padding',
      type: 'string',
      enum: ['0rem', '2rem', '4rem', '6rem', '8rem', '10rem', '12rem', '14rem'],
      enumNames: ['No', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'],
      default: '0rem',
      'ui:hidden': '{{!parentFormData.image}}',
    },
    image: {
      title: 'Image',
      type: 'string',
      default: '',
    },
    tabs: {
      type: 'array',
      title: 'Tabs',
      minItems: 2,
      items: {
        type: 'object',
        required: ['label', 'text'],
        minItems: 1,
        'ui:options': {
          showIndexNumber: true,
        },
        properties: {
          label: {
            title: 'Tab label',
            type: 'string',
            default: DEFAULT_TEXT,
          },
          text: {
            title: 'Text',
            type: 'string',
            default: DEFAULT_MARKDOWN_TEXT,
            'ui:options': {
              placeholder: DEFAULT_MARKDOWN_TEXT,
              type: 'textarea',
              rows: 6,
            },
          },
        },
      },
    },
  },
}
